var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.3 1.05793C-0.1 1.45793 -0.1 2.05793 0.3 2.45793C0.7 2.85793 1.3 2.85793 1.7 2.45793C2.1 2.05793 2.1 1.45793 1.7 1.05793C1.3 0.657935 0.7 0.657935 0.3 1.05793ZM4 1.25793V2.25793H13V1.25793H4ZM0.3 5.05793C-0.1 5.45793 -0.1 6.05793 0.3 6.45793C0.7 6.85793 1.3 6.85793 1.7 6.45793C2.1 6.05793 2.1 5.45793 1.7 5.05793C1.3 4.65793 0.7 4.65793 0.3 5.05793ZM4 6.25793H13V5.25793H4V6.25793ZM0.3 9.05793C-0.1 9.45793 -0.1 10.0579 0.3 10.4579C0.7 10.8579 1.3 10.8579 1.7 10.4579C2.1 10.0579 2.1 9.45793 1.7 9.05793C1.3 8.65793 0.7 8.65793 0.3 9.05793ZM4 10.2579H13V9.25793H4V10.2579Z",
    fill: "#03A9F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBlue);
export default __webpack_public_path__ + "static/media/list-blue.35349276c2234383f2c8b6356c98377e.svg";
export { ForwardRef as ReactComponent };